export default {
	"subscribe.MallRenewalManagementCancelSubscriptionPopupButtonClick": "商城续费管理_取消订阅弹窗_按钮点击",
	"subscribe.Cancel": "取消",
	"subscribe.CancelTheContractSuccessfully": "取消签约成功",
	"subscribe.systemError": "系统错误",
	"subscribe.StoreRenewalManagementRenewalEntry": "商城续费管理_续费入口",
	"subscribe.CloseRenewal": "关闭续费",
	"subscribe.ClickToTurnOffAutoRenewal": "点击关闭自动续费",
	"subscribe.TurnOnRenewal": "开启续费",
	"subscribe.expired": "已失效",
	"subscribe.completed": "已完成",
	"subscribe.StoreRenewalManagementUnsubscribePopup": "商城续费管理_取消订阅弹窗",
	"subscribe.ParameterError": "参数错误!",
	"subscribe.subscriptionTime": "订阅时间",
	"subscribe.nextRenewalTime": "下次续费时间",
	"subscribe.LastRenewalTime": "上次续费时间",
	"subscribe.AmountPerRenewal": "每次续费金额",
	"subscribe.Yuan": "元",
	"subscribe.WeChatPay": "微信支付",
	"subscribe.payByAliPay": "支付宝支付",
	"subscribe.AutoRenewalBenefits": "自动续费权益",
	"subscribe.saveTimeAndEnergy": "省时省力",
	"subscribe.AutomaticRenewalUponExpiration": "到期自动续费",
	"subscribe.exclusivePrivilege": "专属特权",
	"subscribe.EnjoyPremiumContent": "尊享优质内容",
	"subscribe.124HoursBeforeTheExpirationOfEachSubscriptionTheSystemWillAutomaticallyDeductTheFeeFromTheContractedAccountAndActivateTheContentExperiencePermissionForTheNewSubscriptionCycle": "1、每次订阅到期前24小时，系统将自动从签约账户扣费，并开通新订阅周期的内容体验权限。",
	"subscribe.2ThereMayBeADelayInFeedbackDueToThePaymentPlatformForTheActualSubscriptionPleaseReferToTheSubscriptionRecord": "2、因支付平台问题可能存在反馈延迟问题，实际订阅请已订阅记录为准。",
	"subscribe.AutomaticSubscriptionClosingPrompt": "自动订阅关闭提示",
	"subscribe.AfterClosingTheSubscriptionTheSystemWillNotBeAbleToMakeSubsequentDeductionsAndYouWillNotBeAbleToUnlockTheCorrespondingRightsOnTimeAreYouSureYouWantToCancel": "关闭订阅后，系统将无法进行后续的扣费，您也无法按时解锁对应权益，是否确定取消",
	"subscribe.continueToCancel": "继续取消",
	"subscribe.doNotCancel": "不取消"
}